import _slicedToArray from "/var/www/sellox/apps/sellox-web-app/apps/blog/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/var/www/sellox/apps/sellox-web-app/apps/blog/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/var/www/sellox/apps/sellox-web-app/apps/blog/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["condition", "fallback", "children"],
    _excluded2 = ["loading"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import o, { useEffect as P, useState as g } from "react";
import i, { Suspense as d } from "react";

var y = function y(_ref) {
  var r = _ref.condition,
      t = _ref.fallback,
      s = _ref.children,
      e = _objectWithoutProperties(_ref, _excluded);

  return r ? i.createElement(d, _objectSpread({
    fallback: t
  }, e), s) : i.createElement(i.Fragment, null, t);
},
    c = y;

import { useState as m, useEffect as f } from "react";

var b = function b() {
  var _m = m(!1),
      _m2 = _slicedToArray(_m, 2),
      r = _m2[0],
      t = _m2[1];

  return f(function () {
    typeof window != "undefined" && t(!0);
  }, []), r;
},
    p = b;

import { useState as x, useEffect as h } from "react";

var I = function I(r, t) {
  var _x = x(!1),
      _x2 = _slicedToArray(_x, 2),
      s = _x2[0],
      e = _x2[1];

  return h(function () {
    if (typeof IntersectionObserver == "function") {
      var a = new IntersectionObserver(function (_ref2) {
        var _ref3 = _slicedToArray(_ref2, 1),
            n = _ref3[0];

        e(n.isIntersecting);
      }, t);
      return r.current && a.observe(r.current), function () {
        a.disconnect();
      };
    }
  }, [r, t]), s;
},
    u = I;

var v = o.lazy(function () {
  return import("./-DF7QULBM.mjs");
}),
    M = function M(r) {
  var t = r.style,
      s = r.className,
      e = r.onIntersection,
      a = r.placeholder,
      n = o.useRef(null),
      l = u(n);
  return P(function () {
    l && e && e();
  }, [l, e]), o.createElement(o.Fragment, null, o.createElement("mux-player", {
    ref: n,
    "data-mux-player-react-lazy-placeholder": !0,
    placeholder: a,
    style: _objectSpread({
      "--mux-player-react-lazy-placeholder": a ? "url(".concat(a, ");") : ""
    }, t),
    className: s || "",
    nohotkeys: !0,
    "aria-hidden": !0,
    tabIndex: -1
  }, o.createElement("div", {
    "data-mux-player-react-lazy-placeholder-overlay": !0
  })), o.createElement("style", null, "\n        mux-player[data-mux-player-react-lazy-placeholder] {\n          aspect-ratio: 16/9;\n          display: block;\n          background-color: var(--media-background-color, #000);\n          width: 100%;\n          position: relative;\n          background-image: var(--mux-player-react-lazy-placeholder);\n          background-repeat: no-repeat;\n          background-size: var(--media-object-fit, contain);\n          background-position: var(--media-object-position, 50% 50%);\n          --controls: none;\n          --controls-backdrop-color: rgba(0, 0, 0, 0.6);\n        }\n        mux-player [data-mux-player-react-lazy-placeholder-overlay] {\n          position: absolute;\n          inset: 0;\n          background-color: var(--controls-backdrop-color);\n        }\n      "));
},
    k = o.forwardRef(function (r, t) {
  var _r$loading = r.loading,
      s = _r$loading === void 0 ? "viewport" : _r$loading,
      e = _objectWithoutProperties(r, _excluded2),
      a = p(),
      _g = g(function () {
    return s !== "viewport";
  }),
      _g2 = _slicedToArray(_g, 2),
      n = _g2[0],
      l = _g2[1];

  return o.createElement(c, {
    condition: a && n,
    fallback: o.createElement(M, {
      style: e.style,
      className: e.className,
      placeholder: e.placeholder,
      onIntersection: function onIntersection() {
        return l(!0);
      }
    })
  }, o.createElement(v, _objectSpread(_objectSpread({}, e), {}, {
    ref: t
  })));
}),
    N = k;

export { N as default };